import { useQuery } from '@tanstack/react-query';

import { documentsApi } from '@/domain/documents/api';
import { queryOptions } from '@/services/query/queryOptions';

import { documentsKeys } from '@/domain/documents/queries/keys';

export const exportFormatsQuery = (companyId: string) =>
  queryOptions({
    queryKey: documentsKeys.exportFormats(companyId),
    queryFn: () => documentsApi.getExportFormats(),
    // The formats change only with the company's ERP, and the writes that change it invalidate this
    // entry, so it is read once per company per session.
    staleTime: Infinity,
    cacheTime: Infinity,
  });

export const useExportFormats = (companyId: string | null) =>
  useQuery({ ...exportFormatsQuery(companyId ?? ''), enabled: companyId !== null });
